module.exports = __webpack_public_path__ + "img/TECNOLOGIA-CIAZ-1.05492ac1.jpg";